import dayjs from 'dayjs';

export interface Day {
    short: string;
    long: string;
    value: number;
}
export const DAYS: Day[] = [
    {
        short: 'Mon',
        long: 'monday',
        value: 1,
    },
    {
        short: 'Tue',
        long: 'Tuesday',
        value: 2,
    },
    {
        short: 'Wed',
        long: 'Wednesday',
        value: 3,
    },
    {
        short: 'Thur',
        long: 'Thursday',
        value: 4,
    },
    {
        short: 'Fri',
        long: 'Friday',
        value: 5,
    },
    {
        short: 'Sat',
        long: 'Saturday',
        value: 6,
    },
    {
        short: 'Sun',
        long: 'Sunday',
        value: 0,
    },
];
export const getDays = (startDay: string = 'Mon'): Day[] => {
    const index: number = DAYS.findIndex((day: Day) => {
        return day.short === startDay;
    });
    if (index === -1 || index === 0)
        return DAYS;

    return DAYS.slice(index, DAYS.length + index).concat(DAYS.slice(0, index));
}

export const getEndingDay = (startDay: string = 'Mon'): Day => {
    return getDays(startDay).splice(-1)[0];

}

export const getStartDate = (month: dayjs.Dayjs, startDay: string = 'Mon'): dayjs.Dayjs => {
    const startDayObj = DAYS.find((day: Day): boolean => {
        return day.short === startDay;
    });
    const startOfMonth = month.startOf('month');
    let start = startOfMonth.clone();

    while (start.day() !== startDayObj.value) {
        start = start.subtract(1, 'day');
    }

    return start;
}

export const getEndDate = (month: dayjs.Dayjs, endDay: string = 'Sun'): dayjs.Dayjs => {
    const endDayObj = DAYS.find((day: Day): boolean => {
        return day.short === endDay;
    });
    const endOfMonth = month.endOf('month');
    let end = endOfMonth.clone();

    while (end.day() !== endDayObj.value) {
        end = end.add(1, 'day');
    }

    return end;
}

export const loopDates = (start: dayjs.Dayjs, end: dayjs.Dayjs, increase: dayjs.OpUnitType, cb: CallableFunction) => {
    for (let i = 0; i < end.diff(start, increase); i++) {
        cb(start.add(i, increase), i);
    }
};

